const OTHERS_TEXT = 'Others';
const OTHERS_TEXTS = ['others'];
const isOthers = (name: string): boolean => OTHERS_TEXTS.includes(name?.toLowerCase());

// 获取开始日期到结束日期的所有月份日期
const getDates = (
  dates: {
    'start_date': string,
    'end_date': string,
  },
): string[] => {
  const {start_date, end_date} = dates || {};
  const startYear = Number(start_date?.substring(0, 4)),
        endYear = Number(end_date?.substring(0, 4)),
        startMonth = Number(start_date?.substring(5, 7)),
        endMonth = Number(end_date?.substring(5, 7));
  if (!start_date || !end_date || !startYear || !endYear || !startMonth || !endMonth) return [];
  const dateList: string[] = [];
  for (let i = startYear; i <= endYear; i ++) {
    const initJ = i === startYear ? startMonth : 1, maxJ = i === endYear ? endMonth : 12;
    for (let j = initJ; j <= maxJ; j ++) {
      dateList.push(`${i}-${j < 10 ? '0' : ''}${j}-01`);
    }
  }

  return dateList;
}

// 找到某个日期的数据
const getFixedDateList = (
  data: [
    string,
    {
      date: string,
      value: string,
      priority?: string | undefined,
    }[] | null,
  ][] | null,
  date: string,
  metric: string[],
  metricKey: string[],
) => {
  if (Array.isArray(data)) {
    const itemsObj: {[keyName: string]: string} = {};
    for (let j = 0; j < data?.length; j ++) {
      const k = data?.[j];
      const key = k?.[0], list = k?.[1];
      const newKey = k?.[0]?.toLowerCase()?.split(' ')?.join('_');
      if (Array.isArray(list)) {
        for (let m = 0; m < list?.length; m ++) {
          const n = list?.[m];
          if (n?.date == date) {
            itemsObj[newKey] = n?.value;
            if (!metric?.includes(key)) metric?.push(key);
            if (!metricKey?.includes(newKey)) metricKey?.push(newKey);
            break;
          }
          if (m === (list?.length - 1)) {
            itemsObj[newKey] = '';
            if (!metric?.includes(key)) metric?.push(key);
            if (!metricKey?.includes(newKey)) metricKey?.push(newKey);
          }
        }
      }
    }
    return itemsObj;
  } else {
    return {};
  }
}

export {
  getDates,
  getFixedDateList,
  OTHERS_TEXT,
  isOthers,
}
